type SearchResultItem = {
  itemId?: unknown;
};

export const filterSearchResultList = <T extends SearchResultItem>(list: T[] = []): T[] => {
  if (!Array.isArray(list)) return [];
  return list.filter((item: T) => Boolean(item?.itemId));
};
